import { render, staticRenderFns } from "./BCXUserBanner.vue?vue&type=template&id=79077baa&scoped=true"
import script from "./BCXUserBanner.vue?vue&type=script&lang=ts"
export * from "./BCXUserBanner.vue?vue&type=script&lang=ts"
import style0 from "./BCXUserBanner.vue?vue&type=style&index=0&id=79077baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79077baa",
  null
  
)

export default component.exports